module.exports = __webpack_public_path__ + "img/box4-normal0.43775dad.png";